<template>
  <div class="navBar">
    <img v-if="showBackIcon" src="@/assets/image/图标-20.png"  class="navBarImg" alt="" @click="back" />
    <div class="navBarTitle" v-if="title">{{ title }}</div>
    <div class="navBarTitle" v-else>用户考试</div>
    <div @click="examBtnEvent" class="examBtn" v-if="showExamBtn">{{ examBtnTitle }}</div>
    <!-- <nut-navbar
        @on-click-back="back"
        @on-click-desc="examBtnEvent"
        :desc="examBtnTitle"
    >
        <template #content>
            <div class="navBarTitle">{{ title }}</div>
        </template>
        <template #right>
            <div class="navBarTitle">{{ title }}</div>
        </template>
    </nut-navbar> -->
  </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  props:{
    title: {
      default: '用户考试',
      type: String
    },
    examBtnTitle: {
      default: '',
      type: String
    },
    showExamBtn: {
      default: true,
      type: Boolean
    },
    showBackIcon: {
      default: true,
      type: Boolean
    },
  },
  setup(props, ctx) {
    const examBtnEvent = () => {
      if(props.examBtnTitle == '全部题目'){
        ctx.emit('examBtnEvent')
      }else if(props.examBtnTitle == '考试帮助'){
        ctx.emit('examHelpEvent')
      }
    };
    const back = () => {
      ctx.emit('backEvent')
    }
    return{
      examBtnEvent,
      back,
    }
  },
});
</script>
<style lang="scss" scoped>
.navBar{
  position: relative;
  padding: 35px 0 11px;
  background-color: #fff;
  margin-bottom: 10px;
  box-shadow: 0 2px 14px 0 rgba(0,0,0,0.05);
}
.navBarImg{
  position: absolute;
  width: 20px;
  height: 20px;
  left: 20px;
  line-height: 20px;
}
.navBarTitle{
  font-size: 16Px;
  line-height: 20px;
  font-weight: Bold;
  text-align: center;
}
.examBtn{
  position: absolute;
  bottom: 11px;
  right: 20px;
  color: #0088FF;
  font-size: 14Px;
  line-height: 20px;
}
</style>
